<template>
  <nav class="flex gap-20">
    <BtnTab
      v-for="(label, index) in props.labels"
      :key="index"
      :label="label"
      :dark="dark"
      :active="index === activeIndex"
      :hovered="index === hoveredIndex"
      @hover="() => emits('hover', index)"
      @click="handleClick(index)"
    />
  </nav>
</template>

<script setup lang="ts">
import BtnTab from '@/shared/ui/components/button/BtnTab.vue'
type Props = {
  labels: string[]
  activeIndex: number
  hoveredIndex?: number
  disabled?: boolean
  dark?: boolean
}
const props = defineProps<Props>()
const emits = defineEmits(['update:modelValue', 'hover'])

const handleClick = (index: number) => {
  if (props.disabled) return
  emits('update:modelValue', index)
}
</script>
